import React, { useState, useEffect } from "react";
import Modal from 'react-modal';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { StaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { CiClock2, CiCalendar } from "react-icons/ci";
import BookingService from "../services/booking.service";
import ProductService from "../services/product.service";
import CategoryService from "../services/category.service";
import HotelService from "../services/hotel.service";
import UserService from "../services/user.service";
import Select from 'react-select';
import cantons from "../shared/data/cantons.json";
import { useNotifications } from '../context/NotificationProvider';
import { formatTimeTo24Hour } from "../shared/utils/string";
import { Map } from "../components/google_map";
import axios from "../api/axios";
import useAuth from "../hooks/useAuth";
import Autocomplete from 'react-google-autocomplete';
import { useLoadScript } from '@react-google-maps/api';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from 'react-i18next';
import { useTranslatableData } from '../hooks/useTranslatable';
import { useNavigate } from 'react-router-dom';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        position: 'absolute',
        boxshadow: '0 0 10px rgba(0, 0, 0, 0.5)',
        overflowX: 'hidden',
        scrollbarWidth: 'none',
        height: '680px',
    },
};


const customSelectStyles = {
    control: (styles) => ({
        ...styles,
        width: '100%',
        height: '60px',
        padding: '0 15px',
        fontSize: '14px',
        lineHeight: '60px',
        color: '#393D44',
        border: '0',
        borderRadius: '20px',
        background: '#ffffff',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
};

const CreateTaskManagerModal = ({ api }) => {
    Modal.setAppElement('#root');
    // const api = useApi();
    const { t } = useTranslation(['booking']);
    const navigate = useNavigate();

    const [modalIsOpen, setIsOpen] = useState(false);
    const [timePickerIsOpen, setTimePickerIsOpen] = useState(false);
    const [datePickerIsOpen, setDatePickerIsOpen] = useState(false);

    const [value, setValue] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState(new Date());
    const [bookings, setBookings] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [productList, setProductList] = useState([]);
    
    // Use translated data for display
    const translatedCategories = useTranslatableData(categories);
    const translatedSubCategories = useTranslatableData(subCategories);
    const translatedProductList = useTranslatableData(productList);
    const [flypros, setFlypros] = useState([]);
    const [customers, setCustomers] = useState([]);
    const notify = useNotifications();
    const { auth } = useAuth();
    const [startDate, setStartDate] = useState(new Date());
    const [isAddressUpdate, setIsAddressUpdate] = useState(false);
    const [coordinates, setCoordinate] = useState({
        lat: 46.356,
        lng: 6.5641
    });
    const [duoCapability, setDuoCapability] = useState(0);
    const [formData, setFormData] = useState({
        category_id: "",
        subcategory_id: "",
        products: [],
        parent_category_id: "",
        duration: "",
        date: "",
        date_only: "",
        timeBooking: "",
        description: "",
        message: "",
        postcode: "",
        therapist_id: [],
        client_id: "",
        address_id: "",
        // promoCode: "",
        status: "CREATED",
        zip_code: "",
        state: "",
        state_code: "",
        street: "",
        street_number: "",
        city: "",
        country: "Switzerland",
        country_code: "CH",
        latitude: null,
        longitude: null
    });

    const resetForm = () => {
        setFormData({
            category_id: "",
            subcategory_id: "",
            products: [],
            duration: "",
            parent_category_id: "",
            date: "",
            date_only: "",
            timeBooking: "",
            message: "",
            address_id: "",
            description: "",
            postcode: "",
            therapist_id: [],
            client_id: "",
            // promoCode: "",
            status: "CREATED",
            zip_code: "",
            state: "",
            state_code: "",
            street: "",
            street_number: "",
            city: "",
            country: "Switzerland",
            country_code: "CH",
            latitude: null,
            longitude: null,
            hotel_id: auth.user.hotel[0]?.id,
        });
        setSelectedFlyproOption([]);
        setSubCategories([]);
        setProductList([]);
        setCoordinate({
            lat: 46.356,
            lng: 6.5641
        })
        setIsAddressUpdate(false);
    };

    const handleTimeChange = (newValue) => {
        setSelectedTime(newValue);
    };

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        //subtitle.style.color = '#f00';
    }

    const handleOkClick = () => {
        setValue(selectedTime);
        const timeString = selectedTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        setFormData({
            ...formData,
            timeBooking: timeString,
        });
        setTimePickerIsOpen(false);
    };

    const handleCancelClick = () => {
        setTimePickerIsOpen(false);
    };

    const openDatePicker = () => {
        setDatePickerIsOpen(true);
    };

    const closeDatePicker = () => {
        setDatePickerIsOpen(false);
    };

    const handleDatePickerOk = () => {
        const dateString = value.toLocaleDateString('en-CA');
        setFormData({
            ...formData,
            date_only: dateString,
        });
        closeDatePicker();
    };

    // const fetchBookings = async () => {
    //   try {
    //     const response = await BookingService.index({ with: 'address,client,product,creator,therapist' }, api);
    //     setBookings(response);
    //   } catch (error) {

    //   }
    // };

    // useEffect(() => {
    //   fetchBookings();
    // }, []);

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const hotel = auth.user?.hotel?.[0];
        const hotelAddress = hotel?.address || {};

        const time = formatTimeTo24Hour(formData.timeBooking);
        const combinedDateTime = `${formData.date_only} ${time}`;

        const payload = {
            ...formData,
            address_id: hotel?.address_id,
            street: hotelAddress?.street || '',
            city: hotelAddress?.city || '',
            zip_code: hotelAddress?.zip_code || '',
            state: hotelAddress?.state || '',
            latitude: hotelAddress?.latitude || null,
            longitude: hotelAddress?.longitude || null,
            product_id: formData.products[0],
            country: "Switzerland",
            country_code: "CH",
            date: combinedDateTime,
            start_before: combinedDateTime,
            hotel_id: hotel?.id,
            client_id: auth.user?.id,
            device_type: `${navigator.userAgentData?.platform} - ${navigator.userAgentData?.brands?.[1]?.brand}`,
            device_version: navigator.userAgentData?.brands?.[1]?.version
        };

        console.log('primary_address_id : ', auth.user.primary_address_id);
        console.log('form data to be sent : ', payload);

        try {
            const response = await BookingService.store(payload, api);
            if (response.data) {
                closeModal();
            }
        } catch (error) {
            console.error("Booking submission error:", error);
        }
    };


    const fetchAvailableTherapists = async () => {
        if (flypros.length) {
            return flypros;
        }
        try {
            console.log({ date: formData.date, time: formData.timeBooking, latitude: formData.latitude, longitude: formData.longitude })
            if (formData.longitude && formData.latitude && formData.duration && formData.date_only && formData.timeBooking && formData.state) {
                const flypro = await UserService.fetchAvailableTherapists({ is_hotel: true, hotel_id: auth.user?.hotel?.[0]?.id, date: formData.date_only, time: formatTimeTo24Hour(formData.timeBooking), duration: Number(formData.duration), lat: formData.latitude, lng: formData.longitude, zip_code: formData.zip_code }, null, api);
                setFlypros(flypro);
                return flypro;
            } else {
                notify.warn(t('missingData'))
            }
        } catch (error) {

        }
    }

    async function openModal(filters) {
        // resetForm();
        // const hotel = auth.user?.hotel?.[0];
        // const hotelAddress = auth.user?.hotel?.[0]?.address || {};
        // const updatedFilters = {
        //     ...filters,
        //     with: "media,category.parent,domain,sub_products,parent,hotel",
        //     hotel_id: auth.user?.hotel[0]?.id
        // };
        // setDuoCapability(hotel?.duo_capability ?? 0);
        // const categories = await CategoryService.index({ parent_id: null, status: 'ACTIVE' }, api);
        // const customer = await UserService.indexByRole({ with: 'primary_address' }, 'ROLE_CLIENT', api);
        // const productResponse = await ProductService.index(updatedFilters, api);
        // console.log({ productResponse })
        // setCategories(categories);
        // setCustomers(customer);
        // setProductList(productResponse);

        // setFormData((prev) => ({
        //     ...prev,
        //     hotel_id: auth.user?.hotel?.[0]?.id,
        //     address_id: auth.user?.hotel?.[0]?.address_id,
        //     street: hotelAddress?.street || '',
        //     city: hotelAddress?.city || '',
        //     zip_code: hotelAddress?.zip_code || '',
        //     state: hotelAddress?.state || '',
        //     latitude: hotelAddress?.latitude || null,
        //     longitude: hotelAddress?.longitude || null,
        //     country: "Switzerland",
        //     country_code: "CH",
        // }));

        // setCoordinate({
        //     lat: hotelAddress?.latitude,
        //     lng: hotelAddress?.longitude,
        // });

        // setIsOpen(true);
        navigate('/choose-products')
    };

    const closeModal = () => {
        resetForm();
        setIsOpen(false);
    };

    // Handle product change
    const handleProductSelectChange = (selected) => {
        setFormData(prev => ({
            ...prev,
            products: selected ? selected.map(p => p.value) : [],
            duration: selected && selected.length > 0
                ? selected.reduce((total, p) => total + parseInt(p.duration || 0), 0)
                : 0
        }));
    };

    // Handle flypro change
    const handleFlyproChange = (selected) => {
        const limit = duoCapability ? 2 : 1;

        if (selected.length > limit) {
            notify.warn(`Vous ne pouvez sélectionner que ${limit} thérapeute${limit > 1 ? 's' : ''}.`);
            return;
        }

        if (selected?.length) {
            setSelectedFlyproOption(selected);
            setFormData((prev) => ({
                ...prev,
                therapist_id: selected.map((therapist) => therapist.value)
            }));
        } else {
            setSelectedFlyproOption([]);
            setFormData((prev) => ({
                ...prev,
                therapist_id: []
            }));
        }
    };

    // Create options for Category, Subcategory, Product, Flypro
    const categoryOptions = translatedCategories?.length > 0 ? translatedCategories.map(row => ({ value: row.id, label: row.title })) : [];
    const subcategoryOptions = translatedSubCategories?.length > 0 ? translatedSubCategories.map(row => ({ value: row.id, label: row.title })) : [];
    const productOptions = translatedProductList?.length > 0 ? translatedProductList.map(row => ({ value: row.id, label: row.name, duration: row.duration })) : [];
    const flyproOptions = flypros?.length > 0 ? flypros.map(row => ({ value: row.id, label: row.extra?.full_name })) : [];
    const customerOptions = customers?.length > 0 ? customers.map(row => ({ value: row.id, label: row.extra?.full_name })) : [];

    // Determine currently selected options
    const selectedCategoryOption = categoryOptions.find(o => o.value === formData.category_id) || null;
    const selectedSubcategoryOption = subcategoryOptions.find(o => o.value === formData.subcategory_id) || null;
    const selectedProductOption = productOptions.find(o => o.value === formData.product_id) || null;
    // const selectedFlyproOption = flyproOptions.find(option => formData.therapist_id.includes(option.value)) || null;
    const selectedCustomerOption = customerOptions.find(option => option.value === formData.client_id) || null;
    const [selectedFlyproOption, setSelectedFlyproOption] = useState([]);
    // Fonction pour mettre à jour les valeurs du formulaire

    const handleChange = async (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const fetchCoordinates = async () => {
        const { street_number, street, city, state, zip_code } = formData;
        const address = `${street_number} ${street}, ${city}, ${state} ${zip_code}`;

        try {
            const response = await axios.get(
                `https://maps.googleapis.com/maps/api/geocode/json`,
                {
                    params: {
                        address,
                        key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
                    },
                }
            );

            if (response.data.results.length > 0) {
                const location = response.data.results[0].geometry.location;
                setFormData((prev) => ({
                    ...prev,
                    latitude: location.lat,
                    longitude: location.lng,
                }));
                setCoordinate({
                    lat: location.lat,
                    lng: location.lng,
                });
            } else {
                console.error('No results found for the given address.');
            }
        } catch (error) {
            console.error('Error fetching coordinates:', error);
        }
    };
    const [selectedState, setSelectedState] = useState(null);
    const [showMap, setShowMap] = useState(false);

    const handleShowMap = async () => {
        if (!showMap) {
            await fetchCoordinates();
            setShowMap(true);
        } else {
            setShowMap(false);
        }
    };

    useEffect(() => {
        setFlypros([])
    }, [formData]);

    const loadTherapist = async () => {
        try {
            fetchAvailableTherapists();
        } catch (error) {

        }
    };

    const handleCoordinateChange = (coordinates) => {
        setFormData({
            ...formData,
            longitude: coordinates[0]?.lng,
            latitude: coordinates[0]?.lat,
        })
        setCoordinate({
            lat: coordinates[0]?.lng,
            lng: coordinates[0]?.lat,
        })
    }

    const handleStateChange = (data) => {
        let selected = cantons.cantons.find(
            (canton) => canton.name === data?.value
        );
        document.querySelector('input[name="zip_code"]').setAttribute('placeholder', selected?.zip_code_range || '');
        setFormData({
            ...formData, zip_code: ''
        });
        setFormData({
            ...formData,
            state: data?.value,
        });
        setSelectedState(data);
    };

    return (
        <>
            <button onClick={openModal} className="btn-add-client">
                {t('createTask')}
            </button>
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel={t('addBooking')}
            >
                <button className="close-button" onClick={closeModal}>
                    <span className="close-icon">✖</span>
                </button>

                <h2>{t('createTask')}</h2>
                <p>{t('infoNeeded')}</p>
                <div className="form-inscription">
                    <form onSubmit={handleFormSubmit}>
                        <div className="form-text">
                            <label>{t('product')}</label>
                            <Select
                                value={productOptions.filter(option => formData.products?.includes(option.value))}
                                onChange={handleProductSelectChange}
                                options={productOptions}
                                styles={customSelectStyles}
                                isClearable={false}
                                isSearchable
                                isMulti
                                placeholder={t('selectProduct')}
                                noOptionsMessage={() => t('noProducts')}
                            />

                        </div>

                        <div className="form-text">
                            <label>{t('duration')}</label>
                            <input type="number" name="duration" readOnly value={formData.duration} onChange={(e) => setFormData({ ...formData, duration: e.target.value })} />
                        </div>

                        <div className="dates no-position">
                            <div className="form-text dateOfTheBookingParent topMarg">
                                <label>{t('dateOfBooking')}</label>
                                <input
                                    type="date"
                                    name="date_only"
                                    value={formData.date_only}
                                    onChange={(e) => setFormData({ ...formData, date_only: e.target.value })}
                                />
                            </div>
                            <div className="form-text timeOfTheBookingParent topMarg">
                                <label>{t('timeOfBooking')}</label>
                                <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                                    <input
                                        type="time"
                                        name="timeBooking"
                                        value={formData.timeBooking}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setFormData(prev => ({ ...prev, timeBooking: value }));
                                        }}
                                        className="form-control"
                                    />

                                </div>
                            </div>
                        </div>

                        <div className="form-text topMargArea">
                            <label>{t('description')}</label>
                            <textarea className="formTextArea" name="description" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
                        </div>

                        <div className="form-text topMargArea">
                            <label>{t('comment')}</label>
                            <textarea className="formTextArea" name="message" value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} />
                        </div>

                        <div className="form-text" onClick={loadTherapist}>
                            <label>{t('flypro')} *</label>
                            <Select
                                value={selectedFlyproOption}
                                onChange={handleFlyproChange}
                                options={flyproOptions}
                                styles={customSelectStyles}
                                isClearable
                                required
                                isSearchable
                                isMulti
                                placeholder={t('selectFlypro')}
                                noOptionsMessage={() => t('noFlypros')}
                            />
                        </div>

                        {/* <div className="form-text">
          <label>Promo CODE</label>
          <input type="text" name="promoCode" value={formData.promoCode} onChange={(e) => setFormData({ ...formData, promoCode: e.target.value })} />
        </div> */}

                        {formData.latitude && showMap && (<Map
                            coordinates={[coordinates]}
                            mode="edit"
                            containerStyle={{ width: '100%', height: '400px' }}
                            mapOptions={{
                                disableDefaultUI: true,
                                zoomControl: true,
                                mapTypeControl: false,
                                fullscreenControl: true,
                                streetViewControl: false,
                            }}
                            onCoordinateChange={handleCoordinateChange}
                        />)}
                        <button type="submit" className="btn-submit">
                            {t('createTaskButton')}
                        </button>
                    </form>
                </div>
            </Modal>
        </>
    )
};

export default CreateTaskManagerModal;
